import * as React from "react"
import {CircularProgress} from "@mui/material";
import {ButtonSeeker, IconSeeker} from "@ui-seeker/core";

import {PriceEvolutionShowMinMax} from "../../../@signals";



export default function MinMaxButton({ isPercentage }) {
	return <ButtonSeeker
		disabled={PriceEvolutionShowMinMax.value === null}
		variant="outlined"
		onClick={() => PriceEvolutionShowMinMax.value = !PriceEvolutionShowMinMax.value}
		startIcon={PriceEvolutionShowMinMax.value === null
			? <CircularProgress size={11} sx={{ mr: 1 }} />
			: <IconSeeker
				iconWeight="regular"
				icon={PriceEvolutionShowMinMax.value ? 'square-xmark' : 'square'}
			/>
		}
	>
		Show Max/Min {isPercentage ? 'Discount' : 'Price'}
	</ButtonSeeker>
}
